import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DocumentStubStore, DocumentStubState } from './document-stub.store';

@Injectable({ providedIn: 'root' })
export class DocumentStubQuery extends QueryEntity<DocumentStubState> {

  constructor(protected store: DocumentStubStore) {
    super(store);
  }

}
